<script>
export default {
  name: "layout-guest",
  // created() {
  //   let metaThemeColor = document.querySelector("meta[name=theme-color]");
  //   metaThemeColor.setAttribute("content", "#4842b7");
  //   console.log(metaThemeColor);
  // }
};
</script>

<template>
  <div class="layout-guest">
    <div id="app__view">
      <slot />
    </div>
  </div>
</template>
